import {formatPercentage} from '@/_application/core/utils/number';
import {getDiscountPercent} from '@/_application/modules/products/model/price';
import {Product} from '@/_application/modules/products/model/product';

export const SalesPercent = ({product}: {product: Product}) => {
    const salePercent = getDiscountPercent(product);

    if (salePercent <= 0) return <></>;
    return <p>{formatPercentage(salePercent)}</p>;
};
